export default function () {
  return {
    downloads: [],
    downloadsCurrentPage: 1,
    downloadsLastPage: 1,
    downloadsPerPage: 0,
    downloadsTotal: 0,
    indexPage: null,
    search: '',
    pagedownloadLoading: false,
  }
}
